import { Component, Input, Output, OnInit, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-modal-actionable',
    templateUrl: './modal-actionable.component.html',
    styleUrls: ['./modal-actionable.component.scss'],
    standalone: false
})
export class ModalActionableComponent implements OnInit, AfterViewInit {
  @Input() public iconSrc: string;
  @Input() public dataIconSrc: string;
  @Input() public title: string;
  @Input() public color: string;
  @Input() public data: any[];
  @Input() public hideDialog: boolean = false;
  @Output() openModalEvent = new EventEmitter<boolean>(false); 
  @Output() openModalAutomatic = new EventEmitter<boolean>(false); 

  @Input() public sec: string;
  @Input() public type: string;

  @ViewChild("content") cnt:any;

  closeResult = '';
  public obj: any ={};

  constructor(public readonly modalService: NgbModal, private readonly route: ActivatedRoute, public router: Router) { }

  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});
    this.openModalEvent.emit(true);
  }

  close() {
    this.modalService.dismissAll();
  }


  ngOnInit(){
    if(this.type && this.type == "product" && this.sec && this.sec == "order"){
      this.route.queryParams.subscribe(params => {
        Object.keys(params).forEach(element => {
          this.obj.identifier= params[element];
        });
      });
    }
  }
  ngAfterViewInit(){     
      if(this.obj && this.type == "product" && this.obj.identifier && this.sec == "order"){
        this.modalService.open(this.cnt, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});   
        this.openModalAutomatic.emit(this.obj);
      }
  }

}
